import React from 'react'
import ImpersonationBanner from './ImpersonationBanner'
import { useImpersonationBannerManage } from './hooks'

interface Props {}

const ImpersonationBannerContainer: React.FC<Props> = () => {
  const { userName, districtName, impersonationEnable, onLeaveImpersonation } = useImpersonationBannerManage()

  if (!impersonationEnable) {
    return null
  }

  return (
    <ImpersonationBanner
      userName={userName}
      districtName={districtName}
      onLeaveImpersonation={onLeaveImpersonation}
    />
  )
}

export default ImpersonationBannerContainer
